import React, { useCallback, useEffect, useMemo, useState } from "react";
import PageTitle from "../PageTitle";
import useAxios from "../../utilities/useAxios";
import {
	Card,
	DatePicker,
	Space,
	Typography,
	message,
} from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { Button, ConfigProvider } from "antd";
import dayjs from "dayjs";
import "dayjs/locale/ko";
import { antdKoKRSunday as locale } from "../../utilities/weekLocale";
import useIsMobile from "../../hooks/useIsMobile";
import PageHeader from "../common/PageHeader";

dayjs.locale("ko");

const { Text } = Typography;

const DawnWorshipAttendance = () => {
	const isMobile = useIsMobile();
	const [month, setMonth] = useState(dayjs());
	const [data, setData] = useState(null);
	const [loading, setLoading] = useState(false);

	const loadStatus = useCallback(async () => {
		try {
			setLoading(true);
			const res = await useAxios.get("/attendance/status/", {
				params: {
					view: "dawn_worship",
					year: month.year(),
					month: month.month() + 1,
				},
			});
			setData(res.data);
		} catch {
			message.error("새벽예배 현황을 불러오지 못했습니다.");
		} finally {
			setLoading(false);
		}
	}, [month]);

	useEffect(() => {
		loadStatus();
	}, [loadStatus]);

	const dates = data?.dates || [];
	const attendees = useMemo(() => data?.attendees || [], [data?.attendees]);

	return (
		<ConfigProvider locale={locale}>
			<PageTitle title="새벽예배 현황" />
			<div className="page">
				<PageHeader
					title="새벽예배 현황"
				/>
				<Card className="surface-card" loading={loading}>
					<Space
						style={{
							marginBottom: 16,
							width: "100%",
							justifyContent: "space-between",
							flexWrap: "wrap",
						}}>
						<Space>
							<Button
								icon={<LeftOutlined />}
								onClick={() =>
									setMonth((m) => m.subtract(1, "month"))
								}
							/>
							<DatePicker
								inputReadOnly={isMobile}
								picker="month"
								value={month}
								onChange={(v) => v && setMonth(v)}
								allowClear={false}
								format="YYYY년 M월"
							/>
							<Button
								icon={<RightOutlined />}
								onClick={() => setMonth((m) => m.add(1, "month"))}
							/>
						</Space>
						<Text type="secondary">
							참석자 {attendees.length}명 · 오전 6시 30분 이전
							새벽예배 단말기 기록
						</Text>
					</Space>

					{!attendees.length ? (
						<Text type="secondary">
							이 달에 새벽예배에 참석한 인원이 없습니다.
						</Text>
					) : (
						<div className="attendance-table-wrap">
							<table className="attendance-table">
								<thead>
									<tr>
										<th className="attendance-table__name">
											이름
										</th>
										<th>참석</th>
										{dates.map((d) => (
											<th key={d.date} title={d.date}>
												{dayjs(d.date).format("D")}
												<br />
												<span className="attendance-table__weekday">
													{d.weekday_label}
												</span>
											</th>
										))}
									</tr>
								</thead>
								<tbody>
									{attendees.map((row) => (
										<tr key={row.user_id}>
											<td className="attendance-table__name">
												{row.name}
											</td>
											<td>{row.count}</td>
											{dates.map((d) => {
												const time = row.days?.[d.date];
												return (
													<td
														key={d.date}
														title={
															time
																? `${d.date} ${time}`
																: ""
														}
														style={{
															textAlign: "center",
															background: time
																? "#f6ffed"
																: undefined,
														}}>
														{time
															? time.slice(0, 5)
															: ""}
													</td>
												);
											})}
										</tr>
									))}
								</tbody>
							</table>
					</div>
				)}
			</Card>
			</div>
		</ConfigProvider>
	);
};

export default DawnWorshipAttendance;
